var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTtLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 65.861,
    viewBox: "0 0 220 65.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2587",
    "data-name": "Grupo 2587",
    transform: "translate(-568 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2586",
    "data-name": "Grupo 2586",
    transform: "translate(568 35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1229",
    "data-name": "Trazado 1229",
    d: "M286.646,146.036a15.413,15.413,0,1,0,15.414,15.413A15.431,15.431,0,0,0,286.646,146.036Zm8.653,15.413a8.653,8.653,0,1,1-8.653-8.653A8.663,8.663,0,0,1,295.3,161.449Z",
    transform: "translate(-182.792 -133.582)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1230",
    "data-name": "Trazado 1230",
    d: "M380.016,158.65a15.417,15.417,0,0,0-30.415,5.024,15.208,15.208,0,0,0,1.131,3.946,15.416,15.416,0,0,0,28.253,0l.145-.331h-7.889l-.07.075a8.648,8.648,0,0,1-12.629,0,8.741,8.741,0,0,1-2-3.488h23.536l.03-.2a15.638,15.638,0,0,0-.1-5.024Zm-23.278-.194a8.653,8.653,0,0,1,16.238,0Z",
    transform: "translate(-180.863 -133.582)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1231",
    "data-name": "Trazado 1231",
    d: "M399.805,146.083c-.387-.026-.71-.038-1.016-.038a15.3,15.3,0,0,0-8.641,2.648v-2.648H383.38v30.818h6.768V161.955c-.009-.165-.014-.331-.014-.5s.005-.335.014-.5a8.658,8.658,0,0,1,8.641-8.149,8.54,8.54,0,0,1,.975.062l.262.029v-6.8Z",
    transform: "translate(-180.027 -133.582)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1232",
    "data-name": "Trazado 1232",
    d: "M258.9,153.561h8.869v-7.234H258.9V133.882h0a7.234,7.234,0,0,0-7.234,7.234v20.39a15.689,15.689,0,0,0,6.486,12.681,15.53,15.53,0,0,0,9.146,2.951h.471v-7.224H267.3a8.4,8.4,0,0,1-8.4-7.975Z",
    transform: "translate(-183.274 -133.882)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1233",
    "data-name": "Trazado 1233",
    d: "M336.564,165.942l-7.016-19.909h-7.13l-7.055,20.231-7.06-20.231h-7.254l10.726,30.833h7.188l7.06-20.273,7.055,20.273h7.189l10.74-30.833h-7.27l-7.06,20.234Z",
    transform: "translate(-182.057 -133.582)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2583",
    "data-name": "Grupo 2583",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1234",
    "data-name": "Trazado 1234",
    d: "M184.92,146.259H197.3V133.882A12.377,12.377,0,0,0,184.92,146.259Z",
    transform: "translate(-184.92 -133.882)",
    fill: "#e82222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1235",
    "data-name": "Trazado 1235",
    d: "M221.455,133.882a12.377,12.377,0,0,0-12.377,12.377h12.377Z",
    transform: "translate(-184.324 -133.882)",
    fill: "#e82222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1236",
    "data-name": "Trazado 1236",
    d: "M226.054,158.338h8.372V145.961H222.05l-12.377,12.377v12.377H197.3V158.338h12.377V145.961H197.3L184.92,158.338v12.377A12.377,12.377,0,0,0,197.3,183.092h37.129V170.715H222.05V158.338Z",
    transform: "translate(-184.92 -133.584)",
    fill: "#e82222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2585",
    "data-name": "Grupo 2585",
    transform: "translate(78.156 55.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2584",
    "data-name": "Grupo 2584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1237",
    "data-name": "Trazado 1237",
    d: "M262.921,198.051a2.968,2.968,0,0,1-1.265-1,2.536,2.536,0,0,1-.46-1.51h1.754a1.584,1.584,0,0,0,.511,1.065,1.811,1.811,0,0,0,1.273.417,1.961,1.961,0,0,0,1.324-.411,1.33,1.33,0,0,0,.474-1.057,1.155,1.155,0,0,0-.3-.82,1.988,1.988,0,0,0-.734-.489,11.1,11.1,0,0,0-1.215-.374,11.327,11.327,0,0,1-1.589-.525,2.63,2.63,0,0,1-1.043-.828,2.388,2.388,0,0,1-.432-1.5,2.659,2.659,0,0,1,.432-1.51,2.753,2.753,0,0,1,1.208-.993,4.4,4.4,0,0,1,1.8-.345,3.749,3.749,0,0,1,2.38.726,2.683,2.683,0,0,1,1.03,1.993h-1.814a1.313,1.313,0,0,0-.517-.936,1.913,1.913,0,0,0-1.251-.388,1.779,1.779,0,0,0-1.152.36,1.254,1.254,0,0,0-.446,1.036,1.05,1.05,0,0,0,.281.755,1.968,1.968,0,0,0,.712.467,11.075,11.075,0,0,0,1.179.375,12.092,12.092,0,0,1,1.618.546,2.694,2.694,0,0,1,1.066.841,2.421,2.421,0,0,1,.438,1.518,2.721,2.721,0,0,1-.41,1.439,2.957,2.957,0,0,1-1.195,1.087,3.944,3.944,0,0,1-1.848.41A4.467,4.467,0,0,1,262.921,198.051Z",
    transform: "translate(-261.195 -188.175)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1238",
    "data-name": "Trazado 1238",
    d: "M292.032,192.718a2.7,2.7,0,0,1-1.152,1.1,4.268,4.268,0,0,1-2.028.424H287.04V198.3H285.4v-10h3.453a4.35,4.35,0,0,1,1.949.4,2.741,2.741,0,0,1,1.194,1.072,2.929,2.929,0,0,1,.4,1.51A3.019,3.019,0,0,1,292.032,192.718Zm-1.784-.238a1.554,1.554,0,0,0,.46-1.2q0-1.64-1.856-1.639H287.04V192.9h1.813A2,2,0,0,0,290.248,192.481Z",
    transform: "translate(-260.598 -188.172)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1239",
    "data-name": "Trazado 1239",
    d: "M311.244,197.749a4.844,4.844,0,0,1-1.856-1.827,5.427,5.427,0,0,1,0-5.273,4.861,4.861,0,0,1,1.856-1.82,5.391,5.391,0,0,1,5.15,0,4.824,4.824,0,0,1,1.849,1.82,5.477,5.477,0,0,1,0,5.273,4.807,4.807,0,0,1-1.849,1.827,5.391,5.391,0,0,1-5.15,0Zm4.337-1.223a3.139,3.139,0,0,0,1.216-1.294,4.165,4.165,0,0,0,.439-1.949,4.122,4.122,0,0,0-.439-1.943,3.1,3.1,0,0,0-1.216-1.281,3.733,3.733,0,0,0-3.538,0,3.1,3.1,0,0,0-1.216,1.281,4.109,4.109,0,0,0-.439,1.943,4.152,4.152,0,0,0,.439,1.949,3.133,3.133,0,0,0,1.216,1.294,3.674,3.674,0,0,0,3.538,0Z",
    transform: "translate(-260.024 -188.175)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1240",
    "data-name": "Trazado 1240",
    d: "M340.925,198.3l-2.3-4h-1.252v4h-1.639v-10h3.452a4.291,4.291,0,0,1,1.949.4,2.79,2.79,0,0,1,1.195,1.079,2.939,2.939,0,0,1,.4,1.51,2.992,2.992,0,0,1-.569,1.777,2.885,2.885,0,0,1-1.747,1.086l2.475,4.143Zm-3.553-5.309h1.813a1.9,1.9,0,0,0,1.388-.46,1.658,1.658,0,0,0,.468-1.237,1.6,1.6,0,0,0-.461-1.215,1.954,1.954,0,0,0-1.4-.439h-1.813Z",
    transform: "translate(-259.357 -188.172)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1241",
    "data-name": "Trazado 1241",
    d: "M366.563,188.3v1.338H363.9V198.3h-1.639V189.64h-2.676V188.3Z",
    transform: "translate(-258.769 -188.172)",
    fill: "#202d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1242",
    "data-name": "Trazado 1242",
    d: "M384.983,198.051a2.968,2.968,0,0,1-1.265-1,2.536,2.536,0,0,1-.46-1.51h1.755a1.583,1.583,0,0,0,.51,1.065,1.811,1.811,0,0,0,1.273.417,1.961,1.961,0,0,0,1.324-.411,1.33,1.33,0,0,0,.474-1.057,1.155,1.155,0,0,0-.3-.82,1.988,1.988,0,0,0-.734-.489,11.109,11.109,0,0,0-1.215-.374,11.333,11.333,0,0,1-1.589-.525,2.63,2.63,0,0,1-1.043-.828,2.388,2.388,0,0,1-.432-1.5,2.659,2.659,0,0,1,.432-1.51,2.752,2.752,0,0,1,1.208-.993,4.4,4.4,0,0,1,1.8-.345,3.747,3.747,0,0,1,2.38.726,2.684,2.684,0,0,1,1.03,1.993H388.32a1.309,1.309,0,0,0-.517-.936,1.913,1.913,0,0,0-1.251-.388,1.779,1.779,0,0,0-1.152.36,1.254,1.254,0,0,0-.446,1.036,1.05,1.05,0,0,0,.281.755,1.968,1.968,0,0,0,.712.467,11.08,11.08,0,0,0,1.179.375,12.092,12.092,0,0,1,1.618.546,2.693,2.693,0,0,1,1.066.841,2.421,2.421,0,0,1,.439,1.518,2.722,2.722,0,0,1-.41,1.439,2.958,2.958,0,0,1-1.195,1.087,3.945,3.945,0,0,1-1.849.41A4.466,4.466,0,0,1,384.983,198.051Z",
    transform: "translate(-258.185 -188.175)",
    fill: "#202d5b"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtLogo);
export default __webpack_public_path__ + "static/media/TTLogo.82be6af3faee03bbbc285b8d39445177.svg";
export { ForwardRef as ReactComponent };